<template>
  <base-modal :visible="visible" @update:visible="close" :showClose="true">
    <div>
      <div class="content">

        <div v-html="text"></div>

      </div>
      <div class="btn-box cursor-pointer" @click.stop="close">
        已知悉
      </div>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModalLine.vue'
export default {
  components: {
    BaseModal
  },

  props: {
    visible: Boolean,
    text: String
  },

  methods: {
    close() {
      this.$emit('update:visible', false)
    },
  }

}
</script>

<style lang="less" scoped>
::v-deep .dialog-card {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
}

// ::v-deep .custom-overlay {
//   background-color: rgba(0, 0, 0, 0.2);
// }

.content {
  width: auto;
  padding: 24px 20px;
  color: #333333;
  font-size: 14px;
  overflow-y: auto;
  max-height: 40vh;
}

.btn-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 43px;
  background: linear-gradient(to right, #ffda17 0%, #fdbf01 100%);
  color: #333333;
  font-size: 15px;
}

.content-text-yellow {
  font-weight: bold;
  color: #fdbf01;
}

.cursor-pointer{
  cursor: pointer;
}
</style>